(function ($, window) {
  window.beforeWindowWidthResizeFunctions = [];
  $(document).ready(() => {
    windowSizeHelper.setWindowWidth();

    window.addEventListener('resize', function () {
      const beforeResizeFunctionsResults = [];

      beforeWindowWidthResizeFunctions.forEach((callback) => {
        const callbackResult = callback();
        if (typeof callbackResult !== 'undefined') {
          beforeResizeFunctionsResults.push(callbackResult);
        }
      });

      if (beforeResizeFunctionsResults.length > 0) {
        $.when.apply(this, beforeResizeFunctionsResults).then(() => {
          windowSizeHelper.setWindowWidth();
        });
      } else {
        windowSizeHelper.setWindowWidth();
      }
    });
  });
}(jQuery, window));
